import { useEffect, useState } from "react";

/**
 * La même valeur, mais en retard.
 *
 * ⚠️ **Ce n'est pas `useDeferredValue`.** Celui de React reporte un *rendu* ;
 * ici il faut reporter une *requête*. Sans ce délai, « lyon » part en quatre
 * appels dont trois sont périmés avant d'arriver — et le serveur fait un
 * `ilike` sur toute la table à chaque frappe.
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [delayed, setDelayed] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDelayed(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return delayed;
}
